import { Button } from "@material-ui/core";
import {
  formatNameFromPersonObj,
  personAlertColor,
  addressAlertColor,
  incidentAlertColor,
} from "../utils/utils";
import { checkPermission } from "./Roles";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { findWeightRestrictionViolation } from "../Components/SizeAndWeightFrame/utils/utils";
import moment from "moment";

const StyledTableLinkButton = withStyles(() => ({
  root: {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    textDecoration: "underline",
    display: "inline",
    margin: "0",
    padding: "0",
    textTransform: "none",
  },
}))(Button);

//The idNames need to match the row names in parseInactiveIncidents
export const incidentSearchHeaders = [
  { title: "Incident Number", idName: "incidentNumber", show: true },
  { title: "Call Type", idName: "classification", show: true },
  { title: "Call Date/Time", idName: "callTime", show: true },
  { title: "Officer", idName: "primaryOfficerBadge", show: true },
  { title: "From", idName: "occurredFrom", show: true },
  { title: "To", idName: "occurredTo", show: true },
  { title: "Address", idName: "address", show: true },
];

export function parseIncidentSearch(
  arr,
  handleIncidentOpening,
  setShowModal,
  userRoles
) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((incident) => {
      const id = incident?.id;
      const { sealed, locked } = incident || {};
      const canViewLocked = checkPermission(
        userRoles,
        "view_locked_incident",
        "ALL",
        "",
        id
      );
      const canViewSealed = checkPermission(
        userRoles,
        "view_sealed_incident",
        "ALL",
        "",
        id
      );
      const disabled =
        (!canViewLocked && locked) || (!canViewSealed && sealed) ? true : false;
      const incidentNumber = (
        <StyledTableLinkButton
          style={{ color: incidentAlertColor(incident, true, true, true) }}
          data-cy={"tablecell-incident-number-link-" + incident?.id}
          onClick={
            disabled
              ? () => alert("You do not have permission to view this incident")
              : () => {
                  handleIncidentOpening(incident?.id, true);
                  setShowModal(false);
                }
          }
        >
          {incident?.incidentNumber}
        </StyledTableLinkButton>
      );
      const classification = incident?.classification?.name;
      const callTime = incident?.callTime
        ? moment
            .utc(incident?.callTime, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      const primaryOfficerBadge =
        incident?.officerIncidentSpecifics.find(ois => ois.primaryOfficer)
          ?.officer?.deptAttribute?.badge || "";
      const occurredFrom = incident?.incidentDetail?.occurredFrom
        ? moment
            .utc(
              incident?.incidentDetail?.occurredFrom,
              "YYYY-MM-DD HH:mm:ss UTC"
            )
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      const occurredTo = incident?.incidentDetail?.occurredTo
        ? moment
            .utc(
              incident?.incidentDetail?.occurredTo,
              "YYYY-MM-DD HH:mm:ss UTC"
            )
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      // const address = incident?.address?.name
      const address = (
        <Link
          style={{
            textDecoration: "none",
            color: addressAlertColor(incident?.address) || "inherit",
          }}
          data-cy="tablecell-incident-number-link"
          target="_blank"
          rel="noreferrer"
          to={`/mp/map/address/${incident?.address?.id}/null`}
        >
          {incident?.address?.name}
        </Link>
      );
      tempRows.push(
        createIncidentSearchData(
          id,
          incidentNumber,
          classification,
          callTime,
          primaryOfficerBadge,
          occurredFrom,
          occurredTo,
          address
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createIncidentSearchData(
  id,
  incidentNumber,
  classification,
  callTime,
  primaryOfficerBadge,
  occurredFrom,
  occurredTo,
  address
) {
  return {
    id,
    incidentNumber,
    classification,
    callTime,
    primaryOfficerBadge,
    occurredFrom,
    occurredTo,
    address,
  };
}

// *********************************************************************************************************

export const peopleSearchHeaders = incidentId => {
  return [
    { title: "ID", idName: "id", show: true },
    { title: "Name", idName: "name", show: true },
    { title: "Address", idName: "address", show: true },
    { title: "DOB", idName: "dob", show: true },
    { title: "Phone", idName: "phone", show: true },
    // { title: 'Associates', idName: 'associates', show: true },
    // { title: 'History', idName: 'history', show: true },
    { title: "Add", idName: "addButton", show: incidentId ? true : false },
  ];
};

export function parsePeopleSearch(
  arr,
  incidentId,
  handlePersonOpening,
  handleAddPerson,
  setShowModal
) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((person) => {
      const id = person?.id;
      const name = (
        <StyledTableLinkButton
          style={{ color: personAlertColor(person) }}
          data-cy={"tablecell-person-name-link-" + person?.id}
          onClick={() => {
            handlePersonOpening(person?.id, true);
            setShowModal(false);
          }}
        >
          {person?.personalAttribute?.lastName},{" "}
          {person?.personalAttribute?.firstName}{" "}
          {person?.personalAttribute?.middleName}
        </StyledTableLinkButton>
      );
      // const address = person?.personalAttribute?.homeAddress?.name
      const address = (
        <Link
          style={{
            textDecoration: "none",
            color:
              addressAlertColor(person?.personalAttribute?.homeAddress) ||
              "inherit",
          }}
          data-cy="tablecell-incident-number-link"
          target="_blank"
          rel="noreferrer"
          to={`/mp/map/address/${person?.personalAttribute?.homeAddress?.id}/null`}
        >
          {person?.personalAttribute?.homeAddress?.name}
        </Link>
      );
      const dob = person?.personalAttribute?.dob
        ? moment
            .utc(person?.personalAttribute?.dob, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY")
        : "";
      const phone = person?.personalAttribute?.phone;
      // these will be implement in a future ticket
      // const associates = "TBD"
      // const history = "TBD"
      // const addButton = incidentId ? <button style={{ }} data-cy={"tablecell-person-add-link-" + person?.id} onClick={() => { console.log(`Add person ${person?.id} to ${incidentId}`) }}>Add</button> : null
      const addButton = incidentId ? (
        <button
          style={{}}
          data-cy={"tablecell-person-add-to-incident-" + person?.id}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            handleAddPerson(person, incidentId);
          }}
        >
          Add
        </button>
      ) : null;
      // tempRows.push(createPeopleSearchData(id, name, address, dob, phone, associates, history))
      tempRows.push(
        createPeopleSearchData(id, name, address, dob, phone, addButton)
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createPeopleSearchData(id, name, address, dob, phone, addButton) {
  return { id, name, address, dob, phone, addButton };
}
// function createPeopleSearchData(id, name, address, dob, phone, , addButton) {
//   return { id, name, address, dob, phone, addButton };
// }

// *********************************************************************************************************

export const ticketSearchHeaders = [
  { title: "Incident Number", idName: "incidentNumber", show: true },
  { title: "Ticket Number", idName: "ticketNumber", show: true },
  { title: "Issued To", idName: "issuedTo", show: true },
  { title: "Type", idName: "ticketEntry", show: true },
  { title: "Cat", idName: "ticketCategory", show: true },
  { title: "SubCat", idName: "ticketSubCategory", show: true },
  { title: "Viol", idName: "violation", show: true },
];

export function parseTicketSearch(
  arr,
  handleIncidentOpening,
  handleTicketOpening,
  setShowModal,
  handlePersonOpening
) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map(ticket => {
      const id = ticket?.id;
      const incidentNumber = (
        <StyledTableLinkButton
          style={{
            color: incidentAlertColor(ticket?.incident, true, true, true),
          }}
          data-cy={"tablecell-incident-number-link-" + ticket?.incident?.id}
          onClick={() => {
            handleIncidentOpening(ticket?.incident?.id, true);
            setShowModal(false);
          }}
        >
          {ticket?.incident?.incidentNumber}
        </StyledTableLinkButton>
      );
      const ticketNumber = (
        <StyledTableLinkButton
          data-cy={"tablecell-ticket-number-link-" + ticket?.id}
          onClick={() => {
            handleTicketOpening(ticket?.id, true);
            setShowModal(false);
          }}
        >
          {ticket?.ticketNumber || "Click to edit"}
        </StyledTableLinkButton>
      );
      // const issuedTo = `${ticket?.issuedTo?.personalAttribute?.lastName}, ${ticket?.issuedTo?.personalAttribute?.firstName} ${ticket?.issuedTo?.personalAttribute?.middleName}`
      // const issuedTo = formatNameFromPersonObj(ticket?.issuedTo)
      const issuedTo = (
        <StyledTableLinkButton
          style={{ color: personAlertColor(ticket?.issuedTo) }}
          data-cy={"tablecell-person-name-link-" + ticket?.issuedTo}
          onClick={() => {
            handlePersonOpening(ticket?.issuedTo?.id, true);
            setShowModal(false);
          }}
        >
          {formatNameFromPersonObj(ticket?.issuedTo)}
        </StyledTableLinkButton>
      );
      const ticketEntry = ticket?.ticketViolationPrototype?.ticketEntry?.name;
      const ticketCategory =
        ticket?.ticketViolationPrototype?.ticketCategory?.name;
      const ticketSubCategory =
        ticket?.ticketViolationPrototype?.ticketSubCategory?.name;
      const violation = ticket?.ticketViolationPrototype?.fullName;
      tempRows.push(
        createTicketSearchData(
          id,
          incidentNumber,
          ticketNumber,
          issuedTo,
          ticketEntry,
          ticketCategory,
          ticketSubCategory,
          violation
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createTicketSearchData(
  id,
  incidentNumber,
  ticketNumber,
  issuedTo,
  ticketEntry,
  ticketCategory,
  ticketSubCategory,
  violation
) {
  return {
    id,
    incidentNumber,
    ticketNumber,
    issuedTo,
    ticketEntry,
    ticketCategory,
    ticketSubCategory,
    violation,
  };
}

export const vehicleSearchHeaders = incidentId => {
  return [
    { title: "Incident Number", idName: "incidentNumber", show: true },
    { title: "Make", idName: "make", show: true },
    { title: "Model", idName: "model", show: true },
    { title: "Year", idName: "year", show: true },
    { title: "Plate", idName: "plate", show: true },
    { title: "VIN", idName: "vin", show: true },
    { title: "Add", idName: "addButton", show: incidentId ? true : false },
  ];
};

export function parseVehicleSearch(
  arr,
  incidentId,
  handleIncidentOpening,
  handleVehicleOpening,
  handleAddVehicle,
  setShowModal
) {
  let tempRows = [];
  const incidentSplit = arr.map(v => {
    return v.incidents.map(i => {
      const vis = i?.vehicleIncidentSpecifics?.find(
        vis => vis?.vehicle?.id === v?.id
      );
      return { ...v, incident: i, visId: vis?.id };
    });
  });
  const flattened = incidentSplit.flat();
  if (flattened.length > 0) {
    flattened.map((vehicle) => {
      const id = vehicle?.id;
      const incidentNumber = (
        <StyledTableLinkButton
          style={{ color: incidentAlertColor(vehicle?.incident) }}
          data-cy={"tablecell-incident-number-link-" + vehicle.incident?.id}
          onClick={() => {
            handleIncidentOpening(vehicle?.incident?.id, false);
            setShowModal(false);
          }}
        >
          {vehicle?.incident?.incidentNumber}
        </StyledTableLinkButton>
      );
      const make = (
        <StyledTableLinkButton
          data-cy={"tablecell-vehicle-make-link-" + vehicle?.id}
          onClick={() => {
            handleVehicleOpening(vehicle?.visId, false);
          }}
        >
          {vehicle?.vehicleMake?.name || "Unknown Make"}
        </StyledTableLinkButton>
      );
      const model = vehicle?.vehicleModel?.name;
      const year = vehicle?.year;
      const plate = vehicle?.vehiclePlate?.name;
      const vin = vehicle?.vehicleVin?.name;
      const addButton = incidentId ? (
        <button
          style={{}}
          data-cy={"tablecell-vehicle-add-link-" + vehicle?.id}
          onClick={() => handleAddVehicle(vehicle, incidentId)}
        >
          Add
        </button>
      ) : null;
      tempRows.push(
        createVehicleSearchData(
          id,
          incidentNumber,
          make,
          model,
          year,
          plate,
          vin,
          addButton
        )
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createVehicleSearchData(
  id,
  incidentNumber,
  make,
  model,
  year,
  plate,
  vin,
  addButton
) {
  return { id, incidentNumber, make, model, year, plate, vin, addButton };
}

// *********************************************************************************************************

// Columns to include in the result:
// Incident Number (clickable link),
// weigh started at,
// officer badge,
// Weight violation name,
// ticket number,
// dimension violation identified,
// weigh method,
export const sizeAndWeightSearchHeaders = [
  { title: "Incident Number", idName: "incidentNumber", show: true },
  { title: "Start Time", idName: "startedAt", show: true },
  { title: "End Time", idName: "endedAt", show: true },
  { title: "Primary", idName: "primaryBadge", show: true },
  { title: "Violation", idName: "weightViolationName", show: true },
  { title: "Ticket Number", idName: "ticketNumber", show: true },
  { title: "Dimension Vio.", idName: "dimensionViolation", show: true },
  { title: "Weigh Methods", idName: "weightMethods", show: true },
];

//this will be an array of incidents and those incidents will have their tickets. The weight violation will need to be found with a util.
export function parseSizeAndWeightSearch(
  arr,
  handleIncidentOpening,
  handleTicketOpening,
  setShowModal,
  userRoles
) {
  let tempRows = [];
  if (arr.length > 0) {
    //array of size and weight objects
    arr.map((sizeAndWeight) => {
      let {
        incident,
        startedAt,
        endedAt,
        dimensionViolationIdentified,
        weightMethods,
      } = sizeAndWeight || {};
      const id = sizeAndWeight?.id;
      const incidentNumber = (
        <IncidentNumberLink
          focus={false}
          incident={incident}
          userRoles={userRoles}
          openIncident={handleIncidentOpening}
          closeModal={() => setShowModal(false)}
        />
      );
      startedAt = startedAt
        ? moment
            .utc(startedAt, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      endedAt = endedAt
        ? moment
            .utc(endedAt, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      const primaryBadge =
        incident?.officerIncidentSpecifics?.find(ois => ois.primaryOfficer)
          ?.officer?.deptAttribute?.badge || "";
      const weightViolation = findWeightRestrictionViolation(
        incident?.incidentTickets
      );
      const weightViolationName =
        weightViolation?.ticketViolationPrototype?.fullName ||
        weightViolation?.ticketViolationPrototype?.name ||
        "";
      const ticketNumber = weightViolation?.id ? (
        <NumberLink
          buttonId={"weight-violation-" + weightViolation?.id}
          objId={weightViolation?.id}
          label={weightViolation?.ticketNumber || "Click to edit"}
          color={"inherit"}
          sealed={false}
          locked={false}
          isIncident={false}
          userRoles={userRoles}
          handleOpen={handleTicketOpening}
          focus={false}
          closeModal={() => setShowModal(false)}
        />
      ) : (
        "N/A"
      );
      const dimensionViolation = dimensionViolationIdentified ? "Yes" : "No";
      weightMethods = weightMethods?.map(wm => wm?.name).join(", ");
      tempRows.push(
        createSizeAndWeightSearchData(
          id,
          incidentNumber,
          startedAt,
          endedAt,
          primaryBadge,
          weightViolationName,
          ticketNumber,
          dimensionViolation,
          weightMethods
        )
      );

      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createSizeAndWeightSearchData(
  id,
  incidentNumber,
  startedAt,
  endedAt,
  primaryBadge,
  weightViolationName,
  ticketNumber,
  dimensionViolation,
  weightMethods
) {
  return {
    id,
    incidentNumber,
    startedAt,
    endedAt,
    primaryBadge,
    weightViolationName,
    ticketNumber,
    dimensionViolation,
    weightMethods,
  };
}

// *********************************************************************************************************

const IncidentNumberLink = ({
  incident,
  userRoles,
  openIncident,
  focus = true,
  closeModal,
}) => {
  const { id } = incident || "";
  const { sealed, locked } = incident || {};
  const canViewLocked = checkPermission(
    userRoles,
    "view_locked_incident",
    "ALL",
    "",
    id
  );
  const canViewSealed = checkPermission(
    userRoles,
    "view_sealed_incident",
    "ALL",
    "",
    id
  );
  const disabled =
    (!canViewLocked && locked) || (!canViewSealed && sealed) ? true : false;
  return (
    <StyledTableLinkButton
      style={{ color: incidentAlertColor(incident, true, true, true) }}
      data-cy={"tablecell-incident-number-link-" + incident?.id}
      onClick={
        disabled
          ? () => alert("You do not have permission to view this incident")
          : () => {
              openIncident(id, focus);
              focus && closeModal();
            }
      }
    >
      {incident?.incidentNumber}
    </StyledTableLinkButton>
  );
};

const NumberLink = ({
  buttonId,
  objId,
  label,
  color,
  sealed,
  locked,
  isIncident = false,
  userRoles,
  handleOpen,
  focus = true,
  closeModal,
}) => {
  const canViewLocked = isIncident
    ? checkPermission(userRoles, "view_locked_incident", "ALL", "", objId)
    : true;
  const canViewSealed = isIncident
    ? checkPermission(userRoles, "view_sealed_incident", "ALL", "", objId)
    : true;
  const disabled =
    (!canViewLocked && locked) || (!canViewSealed && sealed) ? true : false;
  return (
    <StyledTableLinkButton
      id={buttonId}
      style={{ color: color }}
      onClick={
        disabled
          ? () => alert("You do not have permission to view this incident")
          : () => {
              handleOpen(objId, focus);
              focus && closeModal();
            }
      }
    >
      {label}
    </StyledTableLinkButton>
  );
};
